<template>
    <div class="sub-slimvue">
        <iframe width="100%" scrolling="auto" frameborder="0" :height="$iframeHeight"
                :src="url"></iframe>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';

    export default {
        name       : 'sub-watch-frame',
        data(){
            return {
                url:''
            }
        },
        props: ['urlType'],
        components : {},
        computed: {
            ...mapState(['$md5', '$base64', '$page', '$config', '$lodash', '$helper', '$i18n', '$moment','$route','$iframeHeight']),
        },

        created() {
            let gameCode=this.$helper.helper.getGameCode().game_code;
            let accessToken=this.$helper.cookie.get('oasis-watch-token');
            console.log('type=>'+this.urlType);

            switch(this.urlType){
                case 'attendence':
                    this.url=this.$config.attendenceUrl
                    break;
                case 'line':
                    this.url=this.$config.lineUrl
                    break;
                case 'alarmPolicy':
                    this.url=this.$config.alarmPolicyUrl
                    break;
                case 'alarmGroup':
                    this.url=this.$config.alarmGroupUrl
                    break;
                default:
                    this.url='http://';
                    break;
            }
            this.url=this.url+'?gamecode='+gameCode+'&token='+accessToken+'&udp=true';
        },

        methods: {
        }
    };
</script>

<style type="scss" scoped>
    .sub-slimvue { background: #f4f4f4}
</style>



// WEBPACK FOOTER //
// website/subComponents/watch/frame.vue